//
// Copyright 2023 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, {useEffect} from "react";
import Button from "@material-ui/core/Button";
import * as Utils from "eai-configurator-ui/components/Utils";
import MessageDialog, {useMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/MessageDialog";

const TaskDetailsDialog = ({taskId, handleClosed}) => {
  const [message, setMessage] = useMessageDialog();
  const [messageProps, setMessageProps] = React.useState(null);

  useEffect(() => {
    const fetchDetails = () => {
      if (taskId) {
        Utils.fetchData("auditor/taskDetails?id=" + taskId)
          .then((data) => {
            setMessageProps({info: true, htmlContents: true});
            setMessage(data.detailHtml);
          })
          .catch(function (response) {
            setMessageProps({error: true});
            Utils.getErrorMessage(response, "Request failed.").then(setMessage);
          });
      }
    };

    if (taskId) {
      fetchDetails();
    }
    // eslint-disable-next-line
  }, [taskId]);

  useEffect(() => {
    if (!message.open) {
      handleClosed();
    }
  }, [message.open, handleClosed]);

  const handleCopyToClipboard = () => {
    Utils.copyFormattedHtmlToClipboard(message.description);
  };

  return (
    <MessageDialog
      {...message}
      {...messageProps}
      title="Task Information"
      buttons={[
        <Button key={"copyToClipboard"} color="primary" onClick={handleCopyToClipboard}>
          Copy to clipboard
        </Button>
      ]}
    />
  );
};
export default TaskDetailsDialog;
